import { render, staticRenderFns } from "./VisaCalCredsHelpPopup.vue?vue&type=template&id=48049934&scoped=true&"
import script from "./VisaCalCredsHelpPopup.vue?vue&type=script&lang=js&"
export * from "./VisaCalCredsHelpPopup.vue?vue&type=script&lang=js&"
import style0 from "./VisaCalCredsHelpPopup.vue?vue&type=style&index=0&id=48049934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48049934",
  null
  
)

export default component.exports